export default "__VITE_ASSET__sJkr0asD__"